module.exports = __webpack_public_path__ + "static/media/p8-1.cc56ecc6.png";